import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
    root: {
        paddingTop: '64px'
    }
});

export default useSx;
